import { getData, postRequestWithFormData, putRequestWithJson } from '../utils/HelperFunctions.js';

export const getAccountUser = (paramsObject = {}) => {
    return getData(paramsObject, 'accountuser/view').then(res => res.AccountUser);
};

export const passwordReset = (paramsObject = {}) => {
    return getData(paramsObject, 'accountuser/password_reset').then(res => res);
};

// M7-326: complete a password reset from the emailed LINK. PUTs to
// `users/password` (host + `/api/` are prefixed by the request layer) with the
// reset token and the chosen password. Success => { success: true }; an
// invalid/expired token or a weak/mismatched password comes back 422 and is
// surfaced by baseRequest as an Error whose message is the joined `errors`.
export const setNewPassword = ({ reset_password_token, password, password_confirmation }) => {
    return putRequestWithJson(
        {
            user: {
                reset_password_token,
                password,
                password_confirmation,
            },
        },
        'users/password'
    ).then(res => res);
};

export const sendMessage = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'accountuser/send_message', paramsObject).then(res => res);
};

export const deleteAccountUser = (paramsObject = {}) => {
    return getData(paramsObject, 'accountuser/delete').then(res => res);
};

export const updateAccountUserSettings = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'accountuser/update', paramsObject).then(
        res => res.AccountUser
    );
};

export const createAccountUser = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'accountuser/create', paramsObject).then(
        res => res.AccountUser
    );
};

export const sendWelcomeEmail = (data, paramsObject = {}) => {
    return postRequestWithFormData(data, 'accountuser/send_welcome_email', paramsObject).then(
        res => res
    );
};

export const sendResetUserEmail = (paramsObject = {}) => {
    return getData(paramsObject, 'accountuser/reset_email').then(res => res);
};
